var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickIconSteper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6418 9.78717C23.8802 9.177 22.7688 9.2963 22.154 10.0542L14.868 19.0364C14.675 19.2743 14.3209 19.2987 14.0972 19.0896L10.4497 15.6815C9.82257 15.0955 8.84863 15.0956 8.2217 15.6819C7.53216 16.3266 7.53216 17.4203 8.2217 18.0651L14.3509 23.7962C14.6525 24.0782 15.1292 24.0484 15.3932 23.731L24.8965 12.3071C25.5315 11.5438 25.4167 10.408 24.6418 9.78717Z",
    fill: "#3961A0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#3961A0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIconSteper);
export default __webpack_public_path__ + "static/media/tick_icon_steper.a4b9e4795aa3ff9a84e05ca45d679912.svg";
export { ForwardRef as ReactComponent };